import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Sidebar from "../components/sidebar/sidebar";
import Navbar from "../components/navbar/navbar";
import { useRole } from "../context/role/RoleContext";

const PrivateRoute = () => {
  const accessToken = localStorage.getItem("accessToken");

  const location = useLocation();
  const pathname = location.pathname;

  if (!accessToken) {
    return <Navigate to="/" replace />;
  }

  return (
    <main className="h-full w-full p-2">
      <Navbar />
      <div className="flex gap-2 py-2 h-[calc(100vh-4.5rem)] w-full">
        <div className="hidden lg:block h-full flex-shrink-0 w-[15rem]">
          <Sidebar />
        </div>
        <div className="flex-1 h-full overflow-auto">
          <div className="flex-1 h-full overflow-auto">
            <Outlet />
          </div>
        </div>
      </div>
    </main>
  );
};

export default PrivateRoute;
